import { z } from "zod";

export const updatePushTokenSchema = z.object({
	expo_push_token: z.string(),
});

export type UpdatePushTokenPayload = z.infer<typeof updatePushTokenSchema>;
